/* global axios */

import ApiClient from './ApiClient';

class BrandsAPI extends ApiClient {
  constructor() {
    super('brands', { accountScoped: true });
  }

  setInboxes(brandId, inboxIds) {
    return axios.put(`${this.url}/${brandId}/inboxes`, {
      inbox_ids: inboxIds,
    });
  }
}

export default new BrandsAPI();
